import React, { useState } from 'react';
import {
  Col, Input, FormGroup, FormText,
} from 'reactstrap';

const MultiImageUpload = ({
  setImages,
  title,
}) => {
  const [errorImage, setErrorImage] = useState(null);

  const onImagesUpload = async ({ target: { files } }) => {
    if (!files[0]) {
      return;
    }
    const images = [];
    setErrorImage(null);
    setImages([]);

    for (let index = 0; index < files.length; index += 1) {
      const file = files[index];
      if (file.size > 2 ** 20) {
        setErrorImage('One of uploaded images is more than 1 Mo.');
        return;
      }
      const reader = new FileReader();
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => {
        if (image.height === 960 && image.width === 1280) {
          images.push(image.src);
          if (images.length === files.length) setImages(images);
        } else {
          setErrorImage("One of uploaded images doesn't meet size requirements.");
        }
      };
      reader.onloadend = () => {
        image.src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Col className="section_form_template">
      <h4>{title}</h4>
      <FormGroup>
        <Input type="file" name="background" accept="image/*" onChange={onImagesUpload} multiple />
        <FormText color="muted">
          Uploaded image should be less than 1 Mo and sized 1280x960.
        </FormText>
        {errorImage && (
          <FormText color="danger">
            {errorImage}
          </FormText>
        )}
      </FormGroup>
    </Col>
  );
};

export default MultiImageUpload;



// WEBPACK FOOTER //
// ./src/components/sav-lovebox/components/MultiImageUpload.js